import { z } from 'zod';
import { defineTool } from './types.ts';

export const infoCard = defineTool({
  name: 'render_card',
  description:
    "Show a visual card on the user's screen. Use it whenever you share tips, a plan, a summary or any list the user may want to glance at again. Keep bullets short (under 12 words). Speak a one-sentence version out loud; do not read the whole card.",
  params: z.object({
    title: z.string().min(1).max(80),
    subtitle: z.string().max(140).optional(),
    bullets: z.array(z.string().min(1).max(160)).min(1).max(6),
    tone: z.enum(['neutral', 'tip', 'warning', 'success']).default('neutral'),
  }),
  execution: 'client',
  behavior: 'BLOCKING',
  fixtures: [
    {
      name: 'tips',
      params: {
        title: 'Behavioral interview tips',
        subtitle: 'Amazon PM loop',
        bullets: [
          'Structure every story with STAR',
          'Map each story to a Leadership Principle',
          'Quantify the result, then say what you learned',
        ],
        tone: 'tip',
      },
    },
    {
      name: 'warning',
      params: {
        title: 'Watch your time',
        bullets: ['Answers over 3 minutes lose the interviewer', 'Aim for 90 seconds, then pause'],
        tone: 'warning',
      },
    },
  ],
});
